module.exports = __webpack_public_path__ + "assets/img/dailyTask-top.c7d41557.png";